import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    headerContainer: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    tableHeaderRow: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    statsContainer: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    tableDataRow: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    footerContainer: {
        justifyContent: "flex-end",
        flexDirection: "row"
    },
    emptyStateContainer: {
        justifyContent: "center",
        alignItems: "center",
        minHeight: 120
    },
    loadingContainer: {
        justifyContent: "center",
        alignItems: "center",
        minHeight: 200
    },
    dateCell: {
        alignItems: "flex-end",
        flex: 1.5
    },
    statBarTrack: {
        overflow: "hidden",
        width: "100%"
    },
    notificationImage: {
        width: "100%",
        height: 180
    },
    contentContainer: {
        maxHeight: 650,
        width: "100%"
    },
    statBarFill: {
        height: "100%"
    },
    container: {
        maxWidth: 600,
        width: "100%"
    },
    infoContainer: {
        width: "100%"
    },
    sectionTitle: {
        width: "100%"
    },
    userCell: {
        flex: 2
    },
    mailCell: {
        flex: 2
    }
});
export default stylesheet;
